<template>
  <div class="teams">
    <loading v-if="loading"></loading>
    <div class="user-info" v-else>
      <div class="row">

        <div class="col-md-3 profile-img">
          <img :src="info.image" v-if="info.image !== null">
          <img src="@/assets/img/user/avatar_profile.png" v-else>
        </div>

        <div class="col-sm-12 col-md-9 profile-info">

          <div>
            <p class="user-name"> {{ info.name }} </p>
            <p class="level">Code: {{ info.code }}</p>

            <!--            <div class="user-progress">-->
            <!--              <q-linear-progress size="11px" :value="progress1" color="#0093D2"></q-linear-progress>-->
            <!--            </div>-->
          </div>

          <div class="user-history" v-if="myTeam[0]">
            <div class="body">
              <div class="icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="28.374" height="22.5" viewBox="0 0 28.374 22.5">
                  <path id="crown_1_" data-name="crown (1)"
                        d="M25.16,2.106A3.213,3.213,0,0,0,23.219,7.88L19.1,12.29,15.794,6A3.214,3.214,0,1,0,12.58,6l-3.3,6.294L5.155,7.88a3.213,3.213,0,1,0-2.918.5L4.224,21.557a1.108,1.108,0,0,0,1.1.943H23.054a1.108,1.108,0,0,0,1.1-.943L26.136,8.382a3.214,3.214,0,0,0-.977-6.276ZM3.214,6.318a1,1,0,1,1,1-1A1,1,0,0,1,3.214,6.318Zm10.973-4.1a1,1,0,1,1-1,1A1,1,0,0,1,14.187,2.217ZM22.1,20.283H6.274L4.843,10.793l3.879,4.152a1.109,1.109,0,0,0,1.791-.242l3.674-7,3.674,7a1.109,1.109,0,0,0,1.791.242l3.879-4.152ZM25.16,6.318a1,1,0,1,1,1-1A1,1,0,0,1,25.16,6.318Zm0,0"
                        transform="translate(0 0)"/>
                </svg>
              </div>
              <div class="title">
                <p>{{ myTeam[0].subscriptionCount }}</p>
                <p>Events</p>
              </div>

            </div>
            <div class="body">
              <div class="icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="28.374" height="22.5" viewBox="0 0 28.374 22.5">
                  <path id="crown_1_" data-name="crown (1)"
                        d="M25.16,2.106A3.213,3.213,0,0,0,23.219,7.88L19.1,12.29,15.794,6A3.214,3.214,0,1,0,12.58,6l-3.3,6.294L5.155,7.88a3.213,3.213,0,1,0-2.918.5L4.224,21.557a1.108,1.108,0,0,0,1.1.943H23.054a1.108,1.108,0,0,0,1.1-.943L26.136,8.382a3.214,3.214,0,0,0-.977-6.276ZM3.214,6.318a1,1,0,1,1,1-1A1,1,0,0,1,3.214,6.318Zm10.973-4.1a1,1,0,1,1-1,1A1,1,0,0,1,14.187,2.217ZM22.1,20.283H6.274L4.843,10.793l3.879,4.152a1.109,1.109,0,0,0,1.791-.242l3.674-7,3.674,7a1.109,1.109,0,0,0,1.791.242l3.879-4.152ZM25.16,6.318a1,1,0,1,1,1-1A1,1,0,0,1,25.16,6.318Zm0,0"
                        transform="translate(0 0)"/>
                </svg>
              </div>
              <div class="title">
                <p>{{ myTeam[0].highScore }}</p>
                <p>High Score</p>
              </div>
            </div>
            <div class="body">
              <div class="icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="28.374" height="22.5" viewBox="0 0 28.374 22.5">
                  <path id="crown_1_" data-name="crown (1)"
                        d="M25.16,2.106A3.213,3.213,0,0,0,23.219,7.88L19.1,12.29,15.794,6A3.214,3.214,0,1,0,12.58,6l-3.3,6.294L5.155,7.88a3.213,3.213,0,1,0-2.918.5L4.224,21.557a1.108,1.108,0,0,0,1.1.943H23.054a1.108,1.108,0,0,0,1.1-.943L26.136,8.382a3.214,3.214,0,0,0-.977-6.276ZM3.214,6.318a1,1,0,1,1,1-1A1,1,0,0,1,3.214,6.318Zm10.973-4.1a1,1,0,1,1-1,1A1,1,0,0,1,14.187,2.217ZM22.1,20.283H6.274L4.843,10.793l3.879,4.152a1.109,1.109,0,0,0,1.791-.242l3.674-7,3.674,7a1.109,1.109,0,0,0,1.791.242l3.879-4.152ZM25.16,6.318a1,1,0,1,1,1-1A1,1,0,0,1,25.16,6.318Zm0,0"
                        transform="translate(0 0)"/>
                </svg>
              </div>
              <div class="title">
                <p>{{ myTeam[0].highTime }}</p>
                <p>Best Time</p>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="row add-team-and-achievement">

        <!-- add-team -->
        <div class="col-xs-12 col-sm-12 col-md-6 item add-team"
             v-if="myTeam.length === 0 || myTeam[0].members.find(member => member.id === get_user_id).pivot.status === 2">
          <div class="item-body">
            <div class="body-content">
              <TeamsModal></TeamsModal>
              <p>Add Team</p>
            </div>
          </div>
        </div>

        <!-- Created Team -->
        <div class="col-xs-12 col-sm-12 col-md-6 item team-created"
             v-if="myTeam.length !== 0 && myTeam[0].members.find(member => member.id === get_user_id).pivot.status === 1">
          <div class="item-body">
            <div class="top-body body">
              <div class="row">
                <div class="col-5 team-img">
                  <img :src="myTeam[0].logo">
                </div>
                <div class="col-7 profile-info">
                  <div class="name-wrapper">
                    <a href="javascript:void(0)" @click.prevent="updateTeam = true">
                      <img src="@/assets/img/edit.png" alt="">
                    </a>
                    <p class="user-name"> {{ myTeam[0].name }} </p>
                    <!--                    <div class="user-progress">-->
                    <!--                      <q-linear-progress size="11px" :value="progress1" color="#0093D2"></q-linear-progress>-->
                    <!--                    </div>-->
                    <!--                    <p class="level">88-100 EX</p>-->
                  </div>
                  <div>
                    <q-btn  outline color="blue-grey" label="Info" @click="showMyTeamInfo" />
                  </div>
                </div>
              </div>
            </div>
            <div class="team-info">
              <div class="row">
                <div class="col-9">
                  <p class="head">Team Member</p>
                  <div class="team-member">

                    <template v-for="item in myTeam[0].members">
                      <template v-if="item.id != get_user_id">
                        <img
                            :src=" item.image === null ? require('@/assets/img/user/avatar_profile.png') : ' https://test.wro-v.com/national_organizer/'+ item.image ">
                        <span v-if="item.pivot.status == 0" class="pending">Pending</span>
                      </template>
                    </template>

                    <!-- open modal -->
                    <svg @click="addmember = true" xmlns="http://www.w3.org/2000/svg" width="29.574" height="29.574"
                         viewBox="0 0 29.574 29.574" v-if="myTeam[0].members.length <= 1">
                      <path id="Icon_material-add" data-name="Icon material-add"
                            d="M37.074,24.4H24.4V37.074H20.175V24.4H7.5V20.175H20.175V7.5H24.4V20.175H37.074Z"
                            transform="translate(-7.5 -7.5)"/>
                    </svg>

                    <!-- Delete Member -->
                    <a href="javascript:void(0)" @click.prevent="delete_member(myTeam[0].members[1].id, myTeam[0].id)">
                      <i class="fas fa-minus"
                         v-if="myTeam[0].members.length === 2"></i>
                    </a>


                    <q-dialog v-model="addmember">
                      <q-card>
                        <q-card-section>
                          <div class="text-h6"> {{ myTeam[0].name }}</div>
                        </q-card-section>

                        <q-card-section class="q-pt-none">
                          <add-member :team_id=myTeam[0].id></add-member>
                        </q-card-section>

                      </q-card>
                    </q-dialog>

                  </div>
                </div>
                <div class="col-3">
                  <div class="rate">
                    <p class="head">Completion</p>

                    <!-- team not completed -->
                    <svg id="not-completed" viewBox="0 0 512 512" style=" enable-background:new 0 0 512 512;"
                         xml:space="preserve" v-if="myTeam[0].members.length == 1">
                        <path d="M256,0C114.509,0,0,114.497,0,256c0,141.491,114.497,256,256,256c141.491,0,256-114.497,256-256
                          C512,114.509,397.503,0,256,0z M271,481.513V30.487C387.26,38.051,482,134.618,482,256C482,377.349,387.315,473.945,271,481.513z"/>
                    </svg>
                    <svg v-else viewBox="0 0 507.2 507.2" style=" enable-background:new 0 0 507.2 507.2;">
                      <circle style="fill:#32BA7C;" cx="253.6" cy="253.6" r="253.6"/>
                      <path style="fill:#0AA06E;"
                            d="M188.8,368l130.4,130.4c108-28.8,188-127.2,188-244.8c0-2.4,0-4.8,0-7.2L404.8,152L188.8,368z"/>
                      <path style="fill:#FFFFFF;" d="M260,310.4c11.2,11.2,11.2,30.4,0,41.6l-23.2,23.2c-11.2,11.2-30.4,11.2-41.6,0L93.6,272.8
                              c-11.2-11.2-11.2-30.4,0-41.6l23.2-23.2c11.2-11.2,30.4-11.2,41.6,0L260,310.4z"/>
                      <path style="fill:#FFFFFF;" d="M348.8,133.6c11.2-11.2,30.4-11.2,41.6,0l23.2,23.2c11.2,11.2,11.2,30.4,0,41.6l-176,175.2
                              c-11.2,11.2-30.4,11.2-41.6,0l-23.2-23.2c-11.2-11.2-11.2-30.4,0-41.6L348.8,133.6z"/>
                    </svg>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Accept Team -->
        <div class="col-xs-12 col-sm-12 col-md-6 item team-created accept-team"
             v-if="myTeam[0] && myTeam[0].members.find(member => member.id == get_user_id).pivot.status === 0">
          <div class="item-body">
            <div class="top-body body">
              <div class="row">
                <div class="col-5 team-img">
                  <img :src="myTeam[0].logo">
                </div>
                <div class="col-7 profile-info">
                  <div>
                    <p class="user-name"> {{ myTeam[0].name }} </p>
                    <div class="user-progress">
                      <q-linear-progress size="11px" :value="progress1" color="#0093D2"></q-linear-progress>
                    </div>
                    <p class="level">88-100 EX</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="team-info">
              <div class="row">
                <div class="col-12">
                  <div class="team-member">
                    <div class="the-button">
                      <button class="wro-button secondaryButtons" @click="acceptOrRefuse(1)"><span>Accept</span>
                      </button>
                      <span class="skew-line-w"></span>
                    </div>
                    <div class="the-button refuse">
                      <button class="refuse wro-button secondaryButtons" @click="acceptOrRefuse(2)"><span>Refuse</span>
                      </button>
                      <span class="skew-line-w"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--                &lt;!&ndash; Achievement &ndash;&gt;
                        <div class="col-xs-12 col-sm-12 col-md-6 item achievement">
                          <div class="item-body">
                            <div class="top-body">
                              <div>
                                <p>Achievement </p>

                              </div>
                              <q-linear-progress size="11px" :value="progress1" color="#0093D2"></q-linear-progress>
                            </div>
                            <div class="body">
                              <div class="cup">
                                <img src="@/assets/img/icons/badge.png">
                                <p>TOP one</p>
                              </div>
                              <div class="cup">
                                <img src="@/assets/img/icons/badge.png">
                                <p>TOP one</p>
                              </div>
                              <div class="cup">
                                <img src="@/assets/img/icons/badge.png">
                                <p>TOP one</p>
                              </div>
                            </div>
                            <p class="see-all">See All</p>
                          </div>
                        </div>-->
      </div>
    </div>

    <q-dialog v-model="updateTeam" class="update-team">
      <q-card>
        <q-card-section>
          <div class="text-h6">Update Team</div>
        </q-card-section>

        <q-card-section class="q-pt-none">
          <add-team update="true" @updated="getMyTeam"></add-team>
        </q-card-section>
      </q-card>
    </q-dialog>

  </div>
</template>


<script>
import TeamsModal from "@/components/user/Teams/TeamsModal";
import AddMember from "@/components/user/Teams/AddMember";
import Loading from "@/components/Loading/loading";
import AddTeam from "@/components/user/Teams/AddTeam";

export default {
  components: {Loading, AddMember, TeamsModal, AddTeam},
  data: () => ({
    addmember: false,
    loading: true,
    info: [],
    accept_or_refuse: {
      team_id: null,
      status: null,
    },
    progress1: 0.3,
    progress2: 0.9,
    updateTeam: null
  }),
  computed: {
    progressLabel1() {
      return (this.progress1 * 100).toFixed(2) + '%'
    },
    get_user_id() {
      return this.$store.state.userData.id;
    },
    myTeam() {
      return this.$store.state.userTeam;
    }
  },
  mounted() {
    this.info = this.$store.getters.get_user_data;
    this.getMyTeam();
  },
  methods: {
    getMyTeam() {
      this.updateTeam = false
      this.$API.teams.get_my_team()
          .then(response => {
            this.loading = false;
            this.$store.commit('get_userTeam', response.data);
          })
          .catch(() => {
            this.loading = false;
          });
    },
    acceptOrRefuse(status) {
      this.accept_or_refuse.team_id = this.myTeam[0].id;
      this.accept_or_refuse.status = status;

      this.$API.teams.accpet_or_refuse_team(this.accept_or_refuse)
          .then(response => {
            this.$q.notify({
              message: 'Saved Your Chose .',
              color: 'green'
            })

            this.$API.teams.get_my_team()
                .then(response => {
                  this.$store.commit('get_userTeam', response.data);
                })
                .catch(() => {

                });

          }).catch(error => {
        console.log(error);
      });
    },
    delete_member(player_two_id, team_id) {
      const formData = new FormData();
      formData.append('player_two_id', player_two_id);
      formData.append('team_id', team_id);

      this.$API.teams.delete_member(formData)
          .then(response => {
            this.$q.notify({
              message: 'Player Deleted .',
              color: 'green'
            })

            this.$API.teams.get_my_team()
                .then(response => {
                  this.$store.commit('get_userTeam', response.data);
                })
                .catch(() => {

                });
          })
          .catch(error => {
            this.$toastr.e(error)
          });
    },
    showMyTeamInfo() {
      this.$router.push({name: 'myTeamInfo'})
    }
  },
}
</script>

<style scoped>
.pending {
  font-size: 12px;
  background: #FABB3F;
  padding: 0 5px;
  border-radius: 5px;
  color: #fff;
}

#not-completed {
  fill: #ab0000;
}

.rate svg {
  width: 30px;
  height: 30px;
}

.title {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.name-wrapper {
  display: flex;
  justify-content: space-between;
  flex-direction: row-reverse;
  flex: 1;
}

.name-wrapper img {
  width: 20px;
}


.update-team .q-card {
  padding: 22px 66px 40px 75px;
}

.team-created .team-info .team-member i {
    padding: 4px 5px;
    border: 1px gray solid;
    border-radius: 50%;
}

</style>